import { makeStyles } from "@material-ui/core/styles"

export default makeStyles(theme => ({
    fieldMargin: {
        margin: "5px 0px 5px"
    },
    label: {
        fontSize: "1rem"
    },
    icon: {
        color: "rgba(0, 0, 0, 0.3)",
        "&$checked": {
            color: "#7c7c7c"
        },
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5)
    },
    checked: {},
    hover: {
        "&:hover": {
            backgroundColor: "#fafafa!important"
        }
    }
}))
